import { INITIAL_DRAWER_INFO } from "components/EditorHome/Constants";
import { TemplateRule } from "interfaces";

export const initialState = {
  templateRules: {
    data: [] as TemplateRule[],
    isLoading: false,
  },
  texts: {
    data: [],
    isLoading: false,
  },
  dataAdapters: {
    data: [
      {
        schema: "",
        name: "",
      },
    ],
    isLoading: false,
  },
  isCategorySaving: false,
  catgoryDetails: {
    data: {
      categoryName: "",
      displayName: "",
      categoryGroup: "",
      categoryGroupId: 0,
      adapterName: "",
      spName: "",
      adapterType: "",
    },
    isLoading: false,
  },
  isDisplayNameUpdating: false,
  addCategoryDrawer: INITIAL_DRAWER_INFO,
  addCategoryInitial: {
    categoryName: "",
    displayName: "",
    categoryGroupId: "1",
    adapterName: "",
    spName: "",
    adapterType: "SP",
  },
  settings: {
    data: [],
    isLoading: false,
  },
  updatedSettings: {
    data: [],
    isLoading: false,
  },
  messageTemplatesUpdate: {
    data: [],
    isLoading: false,
  },
};
